import React from 'react';
import BlockImageCollage from './BlockImageCollage';
import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';
import { CloudinaryImageType } from '../../../../../../../types/CloudinaryImageType';
import { BlockContentContext } from '../../../BlockContent.utils';

interface ImageSerializerProps {
  value: { images: CloudinaryImageType[] };
}

export const ImagesBlock = ({ value: { images } }: ImageSerializerProps) => <BlockImageCollage images={images} />;

export const ImagesSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: ImageSerializerProps) => (
      <ArticleBlockContentGridCol>
        <ImagesBlock value={value} />
      </ArticleBlockContentGridCol>
    );
  }
  return ({ value }: ImageSerializerProps) => <ImagesBlock value={value} />;
};
